import script from "./BrandMarquee.vue?vue&type=script&setup=true&lang=ts"
export * from "./BrandMarquee.vue?vue&type=script&setup=true&lang=ts"

import "./BrandMarquee.vue?vue&type=style&index=0&id=984be678&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-984be678"]])

export default __exports__